import React from 'react'
import { Link as LinkBase } from 'react-router-dom'
import { Collapse as CollapseBase, Container as ContainerBase, Hidden, styled } from '@mui/material'
import { KeyboardArrowDown as KeyboardArrowDownBase, Menu as MenuBase, Search as SearchBase } from '@mui/icons-material'

export const Root = styled('div')`
  background-color: ${props => props.theme.palette.brand.white};
  width: 100%;
  z-index: 3;
`

export const HideContainer = styled(Hidden)``

export const Line = styled('div')`
  display: none;
  background-color: ${props => props.theme.palette.custom.alto};
  height: 5px;
  width: 100%;

  ${props => props.theme.breakpoints.up('sm')} {
    display: block;
  }
`

export const TopMenu = styled(ContainerBase)`
  &.MuiContainer-root {
    display: none;
    height: 34px;
    justify-content: flex-end;
    margin-top: 2px;
    width: 100%;
  }

  ${props => props.theme.breakpoints.up('sm')} {
    &.MuiContainer-root {
      display: flex;
    }
  }
`

export const TopMenuItem = styled('div')`
  align-items: center;
  display: flex;
  cursor: pointer;
  height: 100%;
  margin: 0 10.75px;
  position: relative;
  width: auto;

  &:first-of-type {
    margin: 0 10.75px 0 0;
  }

  &:last-of-type {
    margin: 0 0 0 10.75px;
  }

  & > div {
    background-color: ${props => (props.active ? props.theme.palette.custom.caribbeanGreen : 'transparent')};
  }

  &:hover > div {
    background-color: ${props =>
      props.active ? props.theme.palette.custom.caribbeanGreen : props.theme.palette.custom.corduroy};
  }

  &:hover > a {
    color: ${props => props.theme.palette.custom.regalBlue};
  }
`

export const TopMenuLine = styled('div')`
  height: 5px;
  left: 0;
  position: absolute;
  top: -7px;
  width: 100%;
`

export const TopMenuLink = styled('a')`
  color: ${props => props.theme.palette.custom.chathamsBlue};
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  text-decoration: none;
`

export const Menu = styled(ContainerBase)`
  &.MuiContainer-root {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin: 26px auto 22px;
    width: 100%;
  }
`

export const MenuLogo = styled('img')`
  margin: 0 auto 0 0;
`
export const MenuItem = styled(({ active, ...props }) => <div {...props} />)`
  align-items: center;
  border-bottom: ${props => (props.active ? `3px solid ${props.theme.palette.brand.primary}` : 0)};
  display: flex;
  height: 34px;
  margin: 0 20px;
  width: auto;

  &:first-of-type {
    margin: 0;
  }

  &:last-of-type {
    margin: 0 0 0 20px;
  }

  & a {
    color: ${props => (props.active ? props.theme.palette.brand.primary : props.theme.palette.brand.black1)};
  }
`

export const MenuAction = styled('div')`
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 16px;
  text-decoration: none;

  ${props => props.theme.breakpoints.down('md')} {
    display: flex;
    width: 100%;
  }
`

export const MenuIcon = styled(({ active, ...props }) => <KeyboardArrowDownBase {...props} />)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.black1};
    font-size: 1.1rem;
    margin: 0 0 0 10px;
    position: absolute;
    transform: rotateX(${props => (props.active ? '180deg' : '0')});

    ${props => props.theme.breakpoints.down('md')} {
      margin: 0 0 0 auto;
      position: relative;
    }
  }
`

export const MenuLink = styled(({ active, width, ...props }) => <LinkBase {...props} />)`
  color: ${props => (props.active ? props.theme.palette.brand.primary : props.theme.palette.brand.black1)};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 16px;
  text-decoration: none;
  width: ${props => props.width};
`

export const MenuSearch = styled('div')`
  align-items: center;
  background-color: ${props => (props.open ? props.theme.palette.brand.primary : props.theme.palette.brand.white)};
  border: 1.5px solid ${props => props.theme.palette.brand.primary};
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  height: 28px;
  justify-content: center;
  width: 28px;

  &:hover {
    background-color: ${props => props.theme.palette.brand.primary};
  }

  & .MuiSvgIcon-root {
    fill: ${props => (props.open ? props.theme.palette.brand.white : props.theme.palette.brand.primary)};
  }

  &:hover .MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.white};
  }
`

export const SearchIcon = styled(SearchBase)`
  &.MuiSvgIcon-root {
    font-size: 1.2rem;
  }
`
export const MenuContainer = styled('div')`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`

export const MenuList = styled('ul')`
  box-sizing: border-box;
  display: none;
  flex-direction: column;
  list-style: none;
  margin: 0;
  order: 3;
  padding: 0 22px 16px;
  width: 100%;

  &.active {
    display: flex;
  }

  ${props => props.theme.breakpoints.up('md')} {
    display: none;
  }
`

export const MenuListItem = styled(({ active, ...props }) => <li {...props} />)`
  margin: 0 8px;
  padding: 16px 0;

  & > a {
    border-bottom: ${props => (props.active ? `3px solid ${props.theme.palette.brand.primary}` : 0)};
    color: ${props => (props.active ? props.theme.palette.brand.primary : props.theme.palette.brand.black1)};
  }
`

export const MenuToggle = styled(MenuBase)`
  &.MuiSvgIcon-root {
    font-size: 1.2rem;
    cursor: pointer;

    ${props => props.theme.breakpoints.up('lg')} {
      display: none;
    }
  }
`

export const MenuCollapse = styled(CollapseBase)`
  &.MuiCollapse-root .MuiCollapse-wrapper .MuiCollapse-wrapperInner {
    box-sizing: border-box;
    padding: 8px 16px;
    width: 100%;
  }

  &.MuiCollapse-root .MuiCollapse-wrapper .MuiCollapse-wrapperInner a {
    display: flex;
    padding: 8px;
  }
`
export const ItalicBlue = styled('span')`
  font-style: italic;
  color: ${props => props.theme.palette.charts.navyBlue};
`
